import { createApp } from "vue";
import App from "./App.vue";
import List from "./missiondata.js";
const app = createApp(App);
app.config.globalProperties.$missions = List;
app.mount("#app");
